export enum FeatureMode {
  REBATE = 'rebate',
  AUDIT_340B = 'audit_340b'
}

export interface EnvironmentConfiguration {
  production: boolean;
  name: string;
  api: string;
  apiServicesUrl: string;
  freshdeskUrl: string;
  reportingPlatform: {
    baseUrl: string;
    dashboard340B: string;
  };
  auth: {
    auth0Client: string;
    auth0Domain: string;
    audience: string;
  };
  sessionTimeoutMinutes: number;
  featureMode?: FeatureMode;
  enableAuditCustomerMedicaidIntegrations?: boolean;
  enableDemoFeatures?: boolean;
  enableMFPFunctionalFeatures?: boolean;
  enableMfpFinancialDashboardForCeHealthSystemUsers?: boolean;
  enableAllocationManagementForCeHealthSystemUsers?: boolean;
  isDisputeLinkShowAllUser?: boolean;
  isAscensionDemoChanges?: boolean;
  mongoChartsEmbed?: {
    baseUrl: string;
    claimVerificationChart?: {
      id: string;
    };
    claimSourceTrendChart?: {
      id: string;
    };
    verificationTrendChart?: {
      id: string;
    };
    unverifiedClaimReasonChart?: {
      id: string;
    };
    mfpPharmacyDashboard?: {
      id: string;
    };
    rebatePharmacyDashboard?: {
      id: string;
    };
  };
}
